'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthHookLoma = require('@narvar/nth-hook-loma');
var React = require('react');
var nthHookSettings = require('@narvar/nth-hook-settings');
var styled = require('styled-components');
var SessionContext = require('../../../../common/providers/SessionContext.js');
var client = require('@apollo/client');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Image = styled__default["default"].div.withConfig({
  componentId: "sc-2xlau1-0"
})(["width:100%;height:100%;background-image:url(", ");background-position:center;background-size:cover;background-repeat:no-repeat;"], _ref => {
  let {
    backgroundUrl
  } = _ref;
  return backgroundUrl;
});
const ImageMobile = styled__default["default"].img.withConfig({
  componentId: "sc-2xlau1-1"
})(["width:100%;"]);
const OrderLookupHeroImage = _ref2 => {
  let {
    mobile,
    onImageLookupComplete
  } = _ref2;
  const client$1 = nthHookLoma.useLomaClient();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const {
    assets
  } = nthHookSettings.useSettings();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const {
    orderLookupHero
  } = assets || {};
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const {
    assetId = ''
  } = orderLookupHero || {};
  const {
    localeCountry,
    localeLanguage
  } = SessionContext.useSession();
  const {
    data: {
      getMarketingAsset: asset = null
    } = {},
    networkStatus
  } = nthHookLoma.useOrderLookupHeroImageQuery({
    client: client$1,
    variables: {
      id: assetId,
      language: localeLanguage,
      country: localeCountry
    },
    skip: !assetId
  });
  React.useEffect(() => {
    if (networkStatus === client.NetworkStatus.ready) {
      onImageLookupComplete && onImageLookupComplete({
        hasImage: !!(asset !== null && asset !== void 0 && asset.cdnUrl)
      });
    }
  }, [asset, networkStatus, onImageLookupComplete]);
  if (!(asset !== null && asset !== void 0 && asset.cdnUrl)) return null;
  const image = mobile ? /*#__PURE__*/React__default["default"].createElement(ImageMobile, {
    src: asset === null || asset === void 0 ? void 0 : asset.cdnUrl,
    alt: (asset === null || asset === void 0 ? void 0 : asset.altText) || ''
  }) : /*#__PURE__*/React__default["default"].createElement(Image, {
    backgroundUrl: asset === null || asset === void 0 ? void 0 : asset.cdnUrl,
    "aria-label": (asset === null || asset === void 0 ? void 0 : asset.altText) || ''
  });
  return asset !== null && asset !== void 0 && asset.destinationUrl ? /*#__PURE__*/React__default["default"].createElement("a", {
    href: asset.destinationUrl,
    target: "_blank",
    rel: "noreferrer",
    style: {
      display: 'block',
      width: '100%'
    }
  }, image) : image;
};
var OrderLookupHeroImage$1 = nthHookSettings.withSettingsProvider(OrderLookupHeroImage, {
  settingsRequested: 'assets'
});

exports["default"] = OrderLookupHeroImage$1;
